import React, { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../App";
import { Save, Image as ImageIcon } from "lucide-react";

export default function VetTemplate() {
  const [tpl, setTpl] = useState({ logo_url: "", signature_url: "", header_text: "", footer_text: "", qualifications: "", registration_number: "", address: "" });
  const [msg, setMsg] = useState("");

  useEffect(() => {
    axios.get(`${API}/partner/vet/template`).then(r => setTpl({ ...tpl, ...(r.data.template || {}) }));
    // eslint-disable-next-line
  }, []);

  const save = async (e) => {
    e.preventDefault();
    await axios.put(`${API}/partner/vet/template`, tpl);
    setMsg("Saved! New prescriptions will use this template.");
    setTimeout(() => setMsg(""), 2500);
  };

  return (
    <div className="space-y-6 max-w-3xl" data-testid="vet-template-page">
      <div>
        <h1 className="font-heading text-3xl font-extrabold">Clinic template</h1>
        <p className="text-ink-soft text-sm">Upload your logo & signature, set header/footer text — all prescriptions will use this branding.</p>
      </div>

      <form onSubmit={save} className="bg-surface border border-line rounded-3xl p-6 shadow-soft space-y-4" data-testid="template-form">
        <div className="grid md:grid-cols-2 gap-4">
          <F label="Logo URL (clinic logo)">
            <input data-testid="tpl-logo" value={tpl.logo_url || ""} onChange={e => setTpl({...tpl, logo_url: e.target.value})} className="li" placeholder="https://… (PNG/JPG)"/>
            {tpl.logo_url && <img src={tpl.logo_url} alt="logo" className="mt-2 h-14 object-contain bg-surface-muted rounded-xl p-1"/>}
          </F>
          <F label="Signature image URL">
            <input data-testid="tpl-signature" value={tpl.signature_url || ""} onChange={e => setTpl({...tpl, signature_url: e.target.value})} className="li" placeholder="https://… signature scan"/>
            {tpl.signature_url && <img src={tpl.signature_url} alt="sig" className="mt-2 h-14 object-contain bg-surface-muted rounded-xl p-1"/>}
          </F>
        </div>
        <F label="Qualifications (e.g. BVSc & AH, MVSc)">
          <input data-testid="tpl-qual" value={tpl.qualifications || ""} onChange={e => setTpl({...tpl, qualifications: e.target.value})} className="li"/>
        </F>
        <F label="Veterinary Council Registration #">
          <input data-testid="tpl-reg" value={tpl.registration_number || ""} onChange={e => setTpl({...tpl, registration_number: e.target.value})} className="li"/>
        </F>
        <F label="Clinic address">
          <input data-testid="tpl-address" value={tpl.address || ""} onChange={e => setTpl({...tpl, address: e.target.value})} className="li"/>
        </F>
        <F label="Header note (top of prescription)">
          <textarea data-testid="tpl-header" rows={2} value={tpl.header_text || ""} onChange={e => setTpl({...tpl, header_text: e.target.value})} className="li resize-none" placeholder="e.g. Specialist in dermatology & allergies"/>
        </F>
        <F label="Footer note (bottom — disclaimers, instructions)">
          <textarea data-testid="tpl-footer" rows={2} value={tpl.footer_text || ""} onChange={e => setTpl({...tpl, footer_text: e.target.value})} className="li resize-none" placeholder="e.g. In case of emergency, call +91-…"/>
        </F>
        {msg && <div className="text-sm font-bold text-leaf">{msg}</div>}
        <button data-testid="tpl-save" className="bg-brand text-white rounded-full px-6 py-3 font-bold inline-flex items-center gap-2 hover:bg-brand-hover">
          <Save className="w-4 h-4"/> Save template
        </button>
        <style>{`.li{width:100%;border:1px solid #EAE0D5;border-radius:1.5rem;padding:0.6rem 1rem;background:#FFFDF7;font-family:'Nunito';font-weight:600;outline:none;}.li:focus{border-color:#FF6B35;}`}</style>
      </form>
    </div>
  );
}

const F = ({ label, children }) => (
  <label className="block">
    <span className="text-xs font-bold uppercase tracking-wider text-ink-soft">{label}</span>
    <div className="mt-1.5">{children}</div>
  </label>
);
